export default __webpack_public_path__ + "static/media/img-0443-luxembourg-full-face.44f61ca4.png";